import { NgModule } from '@angular/core';
import {
	AlertCircle,
	ArrowDownUp,
	ArrowLeft,
	ArrowRight,
	Bell,
	BellOff,
	Bitcoin,
	Building2,
	Calendar,
	Check,
	CheckSquare,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	CircleCheck,
	CircleDashed,
	CircleHelp,
	CircleX,
	ClipboardCheck,
	ClipboardList,
	Clock,
	CloudUpload,
	Coins,
	Copy,
	CreditCard,
	DollarSign,
	Download,
	Edit,
	EllipsisVertical,
	Euro,
	ExternalLink,
	Eye,
	EyeOff,
	Facebook,
	FileText,
	FileX,
	Globe,
	GripVertical,
	Hash,
	Headphones,
	History,
	Home,
	Image,
	Inbox,
	Info,
	Instagram,
	Landmark,
	LayoutDashboard,
	LayoutGrid,
	List,
	ListChecks,
	ListCollapse,
	ListFilter,
	LoaderCircle,
	Lock,
	LogOut,
	LucideAngularModule,
	Mail,
	MapPin,
	Menu,
	Minus,
	MoveRight,
	Package,
	Palette,
	PanelLeftClose,
	PanelLeftOpen,
	Pencil,
	PencilRuler,
	Percent,
	Phone,
	Plus,
	Receipt,
	RefreshCw,
	Rocket,
	Scale,
	Search,
	Settings,
	Share,
	Shield,
	ShieldCheck,
	ShoppingCart,
	Smartphone,
	SquareDashedMousePointer,
	Squircle,
	Tag,
	ToolCase,
	Trash,
	Trash2,
	TriangleAlert,
	Unlock,
	User,
	Users,
	UsersRound,
	Wallet,
	WandSparkles,
	X,
	Youtube,
	Zap,
} from 'lucide-angular';

@NgModule({
	imports: [
		LucideAngularModule.pick({
			AlertCircle,
			ArrowDownUp,
			ArrowLeft,
			ArrowRight,
			Bell,
			Building2,
			Calendar,
			Check,
			CheckSquare,
			ChevronDown,
			ChevronLeft,
			ChevronRight,
			ChevronUp,
			CircleCheck,
			CircleDashed,
			CircleHelp,
			CircleX,
			ClipboardCheck,
			ClipboardList,
			Clock,
			CloudUpload,
			CreditCard,
			Copy,
			DollarSign,
			Download,
			Edit,
			EllipsisVertical,
			Eye,
			EyeOff,
			FileText,
			FileX,
			Globe,
			Instagram,
			GripVertical,
			Hash,
			Home,
			Image,
			Inbox,
			Info,
			ListFilter,
			LayoutDashboard,
			LayoutGrid,
			List,
			ListChecks,
			ListCollapse,
			LoaderCircle,
			Lock,
			LogOut,
			Mail,
			MapPin,
			Menu,
			Minus,
			MoveRight,
			Package,
			PanelLeftClose,
			PanelLeftOpen,
			Palette,
			Pencil,
			Percent,
			Euro,
			ExternalLink,
			PencilRuler,
			Phone,
			Plus,
			RefreshCw,
			Rocket,
			Scale,
			Search,
			Settings,
			Share,
			Shield,
			ShieldCheck,
			ShoppingCart,
			Smartphone,
			SquareDashedMousePointer,
			Squircle,
			Tag,
			ToolCase,
			Trash,
			Trash2,
			WandSparkles,
			TriangleAlert,
			Unlock,
			User,
			Users,
			UsersRound,
			Wallet,
			X,
			Youtube,
			BellOff,
			Bitcoin,
			Coins,
			Facebook,
			Headphones,
			History,
			Landmark,
			Receipt,
			Zap,
		}),
	],
	exports: [LucideAngularModule],
})
export class LucideModule {}
